<template>
  <div v-if="show" class="popup-overlay" @click.self="close">
    <div class="popup-card" :class="{ 'is-visible': isVisible }">
      <!-- 닫기 -->
      <button class="popup-close-x" @click="close" aria-label="닫기">
        <span></span>
        <span></span>
      </button>

      <div class="popup-scroll">
      <!-- 안내 문구 -->
      <div class="notice-area">
        <span class="notice-eyebrow">NEWS</span>

        <div class="notice-headlines">
          <p class="headline">
            <span class="check">✓</span> 사업계획 <strong>승인완료</strong>
          </p>
          <p class="headline">
            <span class="check">✓</span> <strong>쌍용건설</strong> 시공사 확정
          </p>
        </div>

        <div class="deadline-box">
          <p class="deadline-title">
            <span class="deadline-date">9월 20일</span> 마감
          </p>
          <p class="deadline-main">
            <strong>3천만원 상당 필수옵션</strong> 무상 제공
          </p>
          <p class="deadline-sub">
            발코니 확장 · 시스템 에어컨 · 현관 중문 · 알파룸 중문 등
          </p>
        </div>
      </div>

      <!-- 관심고객등록 폼 -->
      <template v-if="!isSubmitted">
        <p class="form-lead">관심고객으로 등록하시면 상담원이 빠르게 연락드립니다.</p>
        <form @submit.prevent="submitForm" class="register-form">
          <div class="form-group">
            <input
              type="text"
              v-model="form.name"
              class="form-input"
              placeholder="이름"
              required
            />
          </div>
          <div class="form-group">
            <div class="phone-inputs">
              <input
                ref="phone1"
                v-model="form.phone1"
                type="tel"
                inputmode="numeric"
                class="form-input phone-field"
                placeholder="010"
                maxlength="3"
                required
                @input="onPhoneInput('phone1', 3, 'phone2')"
              />
              <span class="phone-dash">-</span>
              <input
                ref="phone2"
                v-model="form.phone2"
                type="tel"
                inputmode="numeric"
                class="form-input phone-field"
                placeholder="0000"
                maxlength="4"
                required
                @input="onPhoneInput('phone2', 4, 'phone3')"
              />
              <span class="phone-dash">-</span>
              <input
                ref="phone3"
                v-model="form.phone3"
                type="tel"
                inputmode="numeric"
                class="form-input phone-field"
                placeholder="0000"
                maxlength="4"
                required
                @input="onPhoneInput('phone3', 4, null)"
              />
            </div>
          </div>

          <label class="agree-label">
            <input type="checkbox" v-model="form.agree" required />
            <span class="checkmark"></span>
            <span class="agree-text">개인정보 수집 및 이용에 동의합니다.</span>
          </label>

          <button type="submit" class="submit-btn" :disabled="isSubmitting">
            {{ isSubmitting ? '등록 중...' : '관심고객 등록하기' }}
          </button>
        </form>
      </template>

      <!-- 등록 완료 -->
      <div v-else class="success-area">
        <div class="success-icon">✓</div>
        <h3>신청이 완료되었습니다</h3>
        <p>빠른 시일 내에 연락드리겠습니다.</p>
        <button class="success-close" @click="close">닫기</button>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'PopupBanner',
  data() {
    return {
      show: false,
      isVisible: false,
      isSubmitting: false,
      isSubmitted: false,
      form: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        agree: false
      }
    }
  },
  mounted() {
    window.addEventListener('splash-done', this.onSplashDone)
    setTimeout(() => {
      if (!this.show) this.open()
    }, 2000)
  },
  beforeUnmount() {
    window.removeEventListener('splash-done', this.onSplashDone)
  },
  methods: {
    onSplashDone() {
      setTimeout(() => this.open(), 500)
    },
    open() {
      if (this.show) return
      this.show = true
      setTimeout(() => { this.isVisible = true }, 50)
    },
    close() {
      this.isVisible = false
      setTimeout(() => { this.show = false }, 400)
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.form[field] = this.form[field].replace(/[^0-9]/g, '')
      if (this.form[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.form.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }

      this.isSubmitting = true

      try {
        await registerCustomer({
          name: this.form.name,
          phone: `${this.form.phone1}${this.form.phone2}${this.form.phone3}`
        })
        // 모비온 데이터매니저 - 상담신청 전환 이벤트
        if (window.callDM) window.callDM('conversion')
        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_4f499454e383'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
        // Google Ads 전환 - 리드 양식 제출
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            send_to: 'AW-17708301937/M9zdCPWT-robEPH8_PtB',
            value: 1.0,
            currency: 'KRW'
          })
        }
        this.isSubmitted = true
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.popup-overlay {
  position: fixed;
  inset: 0;
  z-index: 8000;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(3px);
  padding: 20px;
}

.popup-card {
  position: relative;
  width: 100%;
  max-width: 400px;
  max-height: 92vh;
  display: flex;
  flex-direction: column;
  background: #fff;
  word-break: keep-all;
  opacity: 0;
  transform: translateY(20px) scale(0.97);
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

/* 스크롤은 안쪽 래퍼에만 — 모서리 장식은 카드 테두리에 고정 */
.popup-scroll {
  overflow-y: auto;
  padding: 44px 36px 36px;
}

.popup-card.is-visible {
  opacity: 1;
  transform: translateY(0) scale(1);
}

/* 모서리 장식 */
.popup-card::before,
.popup-card::after {
  content: '';
  position: absolute;
  width: 36px;
  height: 36px;
  border-color: var(--rayone-primary);
  border-style: solid;
  pointer-events: none;
}

.popup-card::before {
  top: 10px;
  left: 10px;
  border-width: 1px 0 0 1px;
}

.popup-card::after {
  bottom: 10px;
  right: 10px;
  border-width: 0 1px 1px 0;
}

/* 닫기 X */
.popup-close-x {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 2;
}

.popup-close-x span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 20px;
  height: 2px;
  background: #333;
  transition: background 0.3s ease;
}

.popup-close-x span:first-child {
  transform: translate(-50%, -50%) rotate(45deg);
}

.popup-close-x span:last-child {
  transform: translate(-50%, -50%) rotate(-45deg);
}

.popup-close-x:hover span {
  background: var(--rayone-primary);
}

/* ===== 안내 문구 ===== */
.notice-area {
  text-align: center;
  margin-bottom: 28px;
}

.notice-eyebrow {
  display: inline-block;
  font-family: var(--font-luxury);
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 6px;
  color: var(--rayone-primary);
  margin-bottom: 16px;
}

.notice-headlines {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 22px;
}

.headline {
  font-family: var(--font-pretendard);
  font-size: 18px;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 1.3;
}

.headline strong {
  font-weight: 700;
  color: var(--rayone-primary);
}

.headline .check {
  color: var(--rayone-primary);
  font-weight: 700;
  margin-right: 2px;
}

/* 마감 강조 박스 */
.deadline-box {
  background: linear-gradient(145deg, var(--rayone-primary) 0%, var(--rayone-primary-dark) 100%);
  color: #fff;
  padding: 22px 20px;
  position: relative;
}

.deadline-title {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  margin-bottom: 10px;
}

.deadline-date {
  color: #ffd76b;
  font-weight: 700;
}

.deadline-main {
  font-family: var(--font-pretendard);
  font-size: 17px;
  font-weight: 500;
  line-height: 1.45;
  margin-bottom: 10px;
}

.deadline-main strong {
  font-weight: 800;
  color: #ffd76b;
}

.deadline-sub {
  font-family: var(--font-pretendard);
  font-size: 12.5px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.5;
}

/* ===== 폼 ===== */
.form-lead {
  font-family: var(--font-pretendard);
  font-size: 13px;
  color: #777;
  text-align: center;
  margin-bottom: 18px;
  line-height: 1.5;
}

.register-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-input {
  width: 100%;
  padding: 13px 16px;
  background: #fafafa;
  border: 1px solid #e0e0e0;
  border-radius: 0;
  font-family: var(--font-pretendard);
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: all 0.3s ease;
}

.form-input::placeholder {
  color: #aaa;
}

.form-input:focus {
  border-color: var(--rayone-primary);
  background: #fff;
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-field {
  flex: 1;
  min-width: 0;
  text-align: center;
}

.phone-dash {
  color: #ccc;
  font-size: 16px;
  flex-shrink: 0;
}

/* 동의 */
.agree-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #888;
  margin-top: 2px;
}

.agree-label input[type="checkbox"] {
  display: none;
}

.checkmark {
  width: 18px;
  height: 18px;
  border: 1.5px solid #ccc;
  border-radius: 2px;
  position: relative;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.agree-label input[type="checkbox"]:checked + .checkmark {
  background: var(--rayone-primary);
  border-color: var(--rayone-primary);
}

.agree-label input[type="checkbox"]:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.agree-text {
  line-height: 1.3;
}

.submit-btn {
  margin-top: 6px;
  padding: 15px;
  background: var(--rayone-primary);
  border: none;
  border-radius: 0;
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover:not(:disabled) {
  background: var(--rayone-primary-dark);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ===== 완료 ===== */
.success-area {
  text-align: center;
  padding: 20px 0 8px;
}

.success-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border: 2px solid var(--rayone-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  color: var(--rayone-primary);
}

.success-area h3 {
  font-family: var(--font-pretendard);
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 10px;
}

.success-area p {
  font-family: var(--font-pretendard);
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

.success-close {
  padding: 12px 32px;
  background: transparent;
  border: 1px solid #ccc;
  font-family: var(--font-pretendard);
  font-size: 14px;
  color: #666;
  cursor: pointer;
  transition: all 0.3s ease;
}

.success-close:hover {
  border-color: var(--rayone-primary);
  color: var(--rayone-primary);
}

/* ===== 모바일 ===== */
@media (max-width: 768px) {
  .popup-card {
    max-width: 340px;
  }

  .popup-scroll {
    padding: 40px 24px 28px;
  }

  .popup-card::before,
  .popup-card::after {
    width: 26px;
    height: 26px;
  }

  .popup-close-x {
    width: 44px;
    height: 44px;
    top: 8px;
    right: 8px;
  }

  .headline {
    font-size: 16px;
  }

  .deadline-main {
    font-size: 17px;
  }

  .deadline-sub {
    font-size: 12px;
  }

  .form-input {
    padding: 14px 16px;
    font-size: 16px; /* prevent iOS zoom */
  }

  .phone-field {
    padding: 14px 8px;
  }

  .agree-label {
    min-height: 44px;
    font-size: 13px;
  }

  .checkmark {
    width: 22px;
    height: 22px;
  }

  .agree-label input[type="checkbox"]:checked + .checkmark::after {
    top: 3px;
    left: 6px;
    width: 6px;
    height: 10px;
  }

  .submit-btn {
    padding: 16px;
    min-height: 48px;
  }
}
</style>
